import { render, staticRenderFns } from "./RemoveAdmin.vue?vue&type=template&id=0cbc51c8&scoped=true&"
import script from "./RemoveAdmin.vue?vue&type=script&lang=js&"
export * from "./RemoveAdmin.vue?vue&type=script&lang=js&"
import style0 from "./RemoveAdmin.vue?vue&type=style&index=0&id=0cbc51c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbc51c8",
  null
  
)

export default component.exports